import axiosInstance from "../../common/axios";

export function fetchLinksApi(pageNumber, unused_link) {
    return axiosInstance.get(`api/request-link-history?page=${pageNumber}&unused_link=${unused_link}`)
}

export function deleteLinksApi(uuid) {
    return axiosInstance.post(`api/delete-video-request/${uuid}/`)
}